import React from 'react';
export const DoctorSection = () => {
  return <div className="flex items-center my-8" data-id="element-89">
      <div className="w-16 h-16 rounded-full flex-shrink-0 mr-4 overflow-hidden" data-id="element-90">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/11ZpR8UUNcTS2ooJufPsJk/Dr._Chen.png" alt="Dr. Marcus Chen, MD" className="w-full h-full object-cover" data-id="element-91" />
      </div>
      <p className="text-lg font-medium" data-id="element-92">By Dr. Marcus Chen, MD</p>
    </div>;
};